import React from 'react';
import Link from 'next/link';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {PersianHelper} from '../../helpers/PersianHelper';
import {AccountingHelper} from 'components/helpers/AccountingHelper';

import _ from 'lodash';
import {BiChevronLeft} from 'react-icons/bi';
import {Skeleton} from 'antd';
import UserOverviewStyles from './styles/UserOverview.module.scss';

/**
 *
 *
 * @param showActionButton
 * @returns {JSX.Element}
 * @constructor
 */
export const UserOverview = ({showActionButton = true}) => {
    const UserState = useSelector((state) => state.User.info);
    const {t} = useTranslation();

    const UserVerificationTag = () => {
        let {waiting_for_upgrade, is_profile_verified} = UserState

        return waiting_for_upgrade === AccountingHelper.waitingForUpgradeStatus.REQUESTED
            ? t('requested') : is_profile_verified ? t('verified') : t('need_to_verify')
    }

    const nameSimplifier = () => {
        let {first_name, last_name} = UserState;
        if (first_name && last_name) {
            return first_name[0] + ' ' + last_name[0]
        }

        return 'ص پ'
    }

    return _.isNull(UserState)
        ? <Skeleton baseColor={'var(--place-holder-one)'} highlightColor={'var(--place-holder-two)'} width={'100%'} height={48}/>
        : <div className={UserOverviewStyles.user_overview}>
            <div className={'info flex-1'}>
                <div>
                    <span>{nameSimplifier()}</span>
                </div>
                <div className='flex-1'>
                    <div className={'user-alias justify-between'}>
                        <p className={'mb-0 font-bold truncate max-w-[50%]'}>
                            {
                                UserState.is_profile_verified
                                    ? `${UserState.first_name} ${UserState.last_name}`
                                    : t('profile_drawer_without_name')
                            }
                        </p>
                        <p className={`${UserOverviewStyles.user_overview__tag} mb-0 text-2xs font-medium`}>
                            <UserVerificationTag/>
                        </p>
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                        <div className={'english-content user-uid text-xs'}>
                            <span className={'ml-1 truncate'}>UID:</span>
                            <span>{UserState.pk + 106879324}</span>
                        </div>
                        <div
                            className={'text-left text-sm text-[var(--text-color-scondary)] font-medium'}>{PersianHelper.mobileConvertToDisplayFormat(UserState.phone) ?? UserState.email}</div>
                    </div>

                </div>
            </div>
            {
                showActionButton &&
                <div className={'action pr-5'}>
                    <Link href={'/profile'} as={'/profile'}>
                        <BiChevronLeft className={'text-xl'}/>
                    </Link>
                </div>
            }
        </div>
};
